<template>
  <div class="grid p-fluid animate__animated animate__fadeIn">
    <div class="col-12">
      <Toast position="top-right" />
      <div class="card card-w-title">
        <h5 class="mb-0">مشتریان</h5>
        <Divider type="dashed" />
        <div class="card grid mt-3 p-0">
          <div v-if="!!places.length" class="col-12 md:col-3">
            <MultiSelect v-model="PlacesId" :options="places" optionLabel="name" optionValue="id" :showToggleAll="false" placeholder="انتخاب اقامتگاه" />
          </div>
          <div class="field col-12 md:col-2">
            <span class="p-input-icon-left">
              <i v-if="!FirstReserveDateRange.from" style="font-size: 1.5rem" class="pi pi-calendar" />
              <i
                v-else
                @click="
                  FirstReserveDateRange.from = null;
                  getCustomersList(pageIndex);
                "
                style="font-size: 1.5rem"
                class="pi pi-calendar-times cursor-pointer"
              />
              <InputText dir="rtl" v-model="FirstReserveDateRange.fromInput" type="text" id="FirstReserveDateRangeFromId" placeholder="اولین تاریخ رزرو از" />
            </span>
            <custom-date-picker auto-submit v-model="FirstReserveDateRange.from" :max="currentDate" format="YYYY-MM-DD" display-format="jYYYY/jMM/jDD" custom-input="#FirstReserveDateRangeFromId" />
          </div>
          <div class="field col-12 md:col-2">
            <span class="p-input-icon-left">
              <i v-if="!FirstReserveDateRange.to" style="font-size: 1.5rem" class="pi pi-calendar" />
              <i
                v-else
                @click="
                  FirstReserveDateRange.to = null;
                  getCustomersList(pageIndex);
                "
                style="font-size: 1.5rem"
                class="pi pi-calendar-times cursor-pointer"
              />
              <InputText dir="rtl" v-model="FirstReserveDateRange.toInput" type="text" id="FirstReserveDateRangeToId" placeholder="آخرین تاریخ رزرو تا" />
            </span>
            <custom-date-picker auto-submit v-model="FirstReserveDateRange.to" :max="currentDate" format="YYYY-MM-DD" display-format="jYYYY/jMM/jDD" custom-input="#FirstReserveDateRangeToId" />
          </div>
          <div class="field col-12 md:col-2">
            <span class="p-input-icon-left">
              <i v-if="!LastReserveDateRange.from" style="font-size: 1.5rem" class="pi pi-calendar" />
              <i
                v-else
                @click="
                  LastReserveDateRange.from = null;
                  getCustomersList(pageIndex);
                "
                style="font-size: 1.5rem"
                class="pi pi-calendar-times cursor-pointer"
              />
              <InputText dir="rtl" v-model="LastReserveDateRange.toInput" type="text" id="LastReserveDateRangeFromId" placeholder="آخرین تاریخ رزرو از" />
            </span>
            <custom-date-picker auto-submit v-model="LastReserveDateRange.from" :max="currentDate" format="YYYY-MM-DD" display-format="jYYYY/jMM/jDD" custom-input="#LastReserveDateRangeFromId" />
          </div>
          <div class="field col-12 md:col-2">
            <span class="p-input-icon-left">
              <i v-if="!LastReserveDateRange.to" style="font-size: 1.5rem" class="pi pi-calendar" />
              <i
                v-else
                @click="
                  LastReserveDateRange.to = null;
                  getCustomersList(pageIndex);
                "
                style="font-size: 1.5rem"
                class="pi pi-calendar-times cursor-pointer"
              />
              <InputText dir="rtl" v-model="LastReserveDateRange.toInput" type="text" id="LastReserveDateRangeToId" placeholder="آخرین تاریخ رزرو تا" />
            </span>
            <custom-date-picker auto-submit v-model="LastReserveDateRange.to" :max="currentDate" format="YYYY-MM-DD" display-format="jYYYY/jMM/jDD" custom-input="#LastReserveDateRangeToId" />
          </div>
          <div class="field col-12 md:col-2">
            <Button @click="getCustomersList(pageIndex)">اعمال فیلتر</Button>
          </div>
        </div>
        <!-- Table Section Begin -->
        <div v-if="!!users.length">
          <DataTable ref="dt" :value="users" dataKey="id" class="overflow-hidden border-round-2xl shadow-1 mt-5 animate__animated animate__fadeIn" responsiveLayout="scroll">
            <template #loading>
              <Loading />
            </template>
            <Column field="firstName">
              <template #header>
                <small class="p-column-title">نام</small>
              </template>
              <template #body="slotProps">
                {{ slotProps.data.firstName }}
              </template>
            </Column>
            <Column field="lastName">
              <template #header>
                <small class="p-column-title">نام خانوادگی</small>
              </template>
              <template #body="slotProps">
                {{ slotProps.data.lastName }}
              </template>
            </Column>
            <Column field="phoneNumber">
              <template #header>
                <small class="p-column-title">شماره همراه</small>
              </template>
              <template #body="slotProps">
                {{ slotProps.data.phoneNumber }}
              </template>
            </Column>
            <Column field="firstReserveDate">
              <template #header>
                <small class="p-column-title">اولین تاریخ رزرو</small>
              </template>
              <template #body="slotProps">
                {{ new Date(slotProps.data.firstReserveDate).toLocaleDateString("fa-IR") }}
              </template>
            </Column>
            <Column field="lastReserveDate">
              <template #header>
                <small class="p-column-title">آخرین تاریخ رزرو</small>
              </template>
              <template #body="slotProps">
                {{ new Date(slotProps.data.lastReserveDate).toLocaleDateString("fa-IR") }}
              </template>
            </Column>
            <Column field="totalPaid">
              <template #header>
                <small class="p-column-title">(تومان)مجموع پرداختی</small>
              </template>
              <template #body="slotProps">
                {{ slotProps.data.totalPaid.toLocaleString("fa-IR") }}
              </template>
            </Column>
            <Column field="reservedCount">
              <template #header>
                <small class="p-column-title">تعداد کل رزرو ها</small>
              </template>
              <template #body="slotProps">
                {{ slotProps.data.reservedCount }}
              </template>
            </Column>
          </DataTable>
          <Paginator :rows="pageSize" :totalRecords="totalCount" @page="changePaging($event)"></Paginator>
        </div>
        <div v-else class="w-full text-center my-3">
          <InlineMessage>موردی وجود ندارد</InlineMessage>
        </div>
        <!-- Table Section End -->
      </div>
    </div>
  </div>
</template>

<script>
import { handleQuery } from "@/utils/index";
export default {
  name: "users",
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 1,
      pageCount: 1,
      places: [],
      users: [
        // {
        //   "data": [
        //     {
        //       "userId": 0,
        //       "firstName": "string",
        //       "lastName": "string",
        //       "phoneNumber": "string",
        //       "totalPaid": 0,
        //       "reservedCount": 0,
        //       "firstReserveDate": "2022-10-31T18:48:13.712Z",
        //       "lastReserveDate": "2022-10-31T18:48:13.712Z"
        //     }
        //   ],
        //   "pageIndex": 0,
        //   "pageSize": 0,
        //   "totalCount": 0,
        //   "pageCount": 0
        // }
      ],
      currentDate: `${new Date(Date.now()).getFullYear()}-${new Date(Date.now()).getMonth() + 1}-${new Date(Date.now()).getDate() + 1}`,
      totalItemsCount: null,
      PlacesId: null,
      FirstReserveDateRange: {
        from: null,
        to: null,
        fromInput: null,
        toInput: null,
      },
      LastReserveDateRange: {
        from: null,
        to: null,
        fromInput: null,
        toInput: null,
      },
      TotalPaidRange: {
        from: null,
        to: null,
        fromInput: null,
        toInput: null,
      },
    };
  },
  methods: {
    //******* Api methods begin *******//
    async getCustomersList(page = 1) {
      let params = {
        PageIndex: page,
        PageSize: this.pageSize,
        PlacesId: !!this.PlacesId?.length ? this.PlacesId : null,
        "FirstReserveDateRange.to": this.FirstReserveDateRange.to,
        "FirstReserveDateRange.from": this.FirstReserveDateRange.from,
        "LastReserveDateRange.to": this.LastReserveDateRange.to,
        "LastReserveDateRange.from": this.LastReserveDateRange.from,
      };
      const { status, data } = await this.axios.get(`reserve/customer`, { params: params, paramsSerializer: handleQuery });
      if (status === 200) {
        this.pageSize = Number(data.pageSize);
        this.pageIndex = data.pageIndex;
        this.totalCount = Number(data.totalCount);
        this.pageCount = +data.pageCount;
        this.users = [...data.data];
      }
    },
    async getListPlaces(page = 1) {
      const { status, data } = await this.axios({ method: "get", url: `Place/GetAll?TitleQuery=&PageIndex=${page}&PageSize=${this.pageSize}` });
      this.totalItemsCount = data.pageCount;
      // this.places.push({id:null , name:'همه'})
      this.places.push.apply(this.places, data.data);
      // this.places = [...data.data];
      // setTimeout(()=>{
      //     this.loading['getData'] = false;
      // },1000)
    },
    //******* Api methods end *******//
    changePaging(e) {
      this.getCustomersList(++e.page);
    },
  },
  async created() {
    await this.getCustomersList();
    this.getListPlaces();
  },
};
</script>
